module.exports = __webpack_public_path__ + "img/time-limit-icon.12673615.png";